export const name = 'editorPopups' as const
export const EditorPopupsSymbol = Symbol('editorPopupsSymbol')
